/** The most events one explore page returns, and so the most members one page of groups can show. */
export const GROUP_DATES_PAGE_SIZE = 250;

/** The fields of an `/events/explore` hit's document the dates read. */
export type MemberEventDocument = {
  id?: string;
  group?: { id?: string | null } | null;
  /** Unix seconds. */
  startDate?: number | null;
  timezone?: string | null;
};

/** One end of a group's date range: the instant and the zone of the event that holds it. */
export type GroupDateEnd = { at: number; timezone?: string | null };

export type GroupDateRange = { first: GroupDateEnd; last: GroupDateEnd };

/** What the Dates cell knows: still asking, failed, or the range per group id (a group with no dated member has none). */
export type GroupDatesState =
  | { status: "loading" }
  | { status: "error" }
  | { status: "ready"; ranges: Record<string, GroupDateRange> };

/** The `group.id` filter of the one members query: every visible group id, no duplicates. */
export const memberFilterIds = (ids: string[]): string[] => [...new Set(ids)];

/**
 * The earliest and latest member start date of each group. A member without a start date counts
 * for nothing, and a hit without a group is not a member.
 */
export const rangesByGroup = (
  documents: MemberEventDocument[],
): Record<string, GroupDateRange> => {
  const ranges: Record<string, GroupDateRange> = {};
  for (const doc of documents) {
    const id = doc.group?.id;
    if (!id || typeof doc.startDate !== "number") continue;
    const end: GroupDateEnd = { at: doc.startDate, timezone: doc.timezone };
    const range = ranges[id];
    if (!range) {
      ranges[id] = { first: end, last: end };
      continue;
    }
    if (end.at < range.first.at) range.first = end;
    if (end.at > range.last.at) range.last = end;
  }
  return ranges;
};
